import styles from './stats-content.module.sass';
import classNames from 'classnames/bind';
import { RefuelingStatCard } from './refueling-stat-card';
import { useEnterpriseDriversRefuelingAmountInfo } from '../use-enterprise-drivers-refueling-amount-info';

const cx = classNames.bind(styles);

export const StatsContent = ({ className }) => {
  const { enterpriseDriversRefuelingAmountInfo } = useEnterpriseDriversRefuelingAmountInfo();

  if (enterpriseDriversRefuelingAmountInfo == null) {
    return null;
  }

  const { title, currentMonth, lastMonth } = enterpriseDriversRefuelingAmountInfo;

  return (
    <div className={cx('container', className)}>
      <RefuelingStatCard title={title} currentMonthAmount={currentMonth} lastMonthAmount={lastMonth} />
    </div>
  );
};
